import { searchOptionsForMode, DOUBLES, FRIENDLIES, RANKED } from 'react/matchmaking/findMatch/findMatchModes';
import { __ } from 'i18n/index';

// The mode an LFG posts for a Play mode. LFGs are never ranked, since ranked
// is only found through automatic matching, so Ranked falls back to Friendlies.
export function lfgModeFor(mode) {
	return mode === RANKED ? FRIENDLIES : mode;
}

// "+ Friendlies" or "+ Doubles": the composer button, named after what it posts.
export function lfgButtonLabel(mode) {
	return lfgModeFor(mode) === DOUBLES ? __('+ Doubles') : __('+ Friendlies');
}

// ChatMessages.postLfg's options for a mode: its team size and saved set
// length, the title, and your main for the room.
export function lfgPostRequest(mode, modeSettings, chatRoomId, title = '') {
	const options = searchOptionsForMode(lfgModeFor(mode), modeSettings, null);
	const main = typeof myUser !== 'undefined' && myUser && myUser.chat_rooms ? myUser.chat_rooms.getMain(chatRoomId) : null;
	return {
		matchCount: options.gameCount || 0,
		ranked: false,
		teamSize: options.teamSize || 1,
		title,
		main,
	};
}
